module.exports = __webpack_public_path__ + "img/backyard-alt-wide.0a7836af.webp";